import { Formatter } from "@skinsoft/types"
import { API_ENDPOINTS } from "@skinsoft/network"
import { DataStore } from "@skinsoft/data-store"

export class FormatterDataStore extends DataStore<Formatter> {
    public static getInstance() {
        if (!FormatterDataStore.instance) {
            FormatterDataStore.instance = new FormatterDataStore()
        }

        return FormatterDataStore.instance
    }

    public static install(Vue) {
        Vue.prototype.$FormatterDataStore = FormatterDataStore.getInstance()
    }

    private static instance: FormatterDataStore = null as any

    constructor() {
        super(API_ENDPOINTS.formatter, ['formatter'])
    }

    protected initializeDataFetcher() {
        //throw new Error("Method not implemented.")
    }

    protected initializeDataPusher() {
        //throw new Error("Method not implemented.")
    }
}